import React from 'react';
import PropTypes from 'prop-types';
import styles from './NoApplicantsEmptyState.module.scss';
import { Button } from 'react-bootstrap';

const NoApplicantsEmptyState = ({ tab = 'invited', browseURL = '/browse' }) => {
  const getEmptyStateContent = () => {
    switch (tab) {
      case 'applied':
        return {
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="68"
              height="68"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={styles.icon}
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          ),
          title: 'No experts have applied',
          description:
            'Browse our network and invite experts to apply to this job.',
          ctaText: 'Browse experts',
          ctaHref: browseURL,
        };

      case 'declined':
        return {
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="68"
              height="68"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="m15 9-6 6" />
              <path d="m9 9 6 6" />
            </svg>
          ),
          title: 'No applicants declined',
          description: null,
          ctaText: null,
          ctaHref: null,
        };

      case 'shortlisted':
        return {
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="68"
              height="68"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
            </svg>
          ),
          title: 'No applicants shortlisted',
          description: null,
          ctaText: null,
          ctaHref: null,
        };

      case 'hired':
        return {
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="68"
              height="68"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={styles.icon}
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <polyline points="16 11 18 13 22 9" />
            </svg>
          ),
          title: 'No applicants hired',
          description: null,
          ctaText: null,
          ctaHref: null,
        };

      case 'invited':
      default:
        return {
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="68"
              height="68"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={styles.icon}
            >
              <circle cx="10" cy="8" r="5" />
              <path d="M2 21a8 8 0 0 1 10.434-7.62" />
              <circle cx="18" cy="18" r="3" />
              <path d="m22 22-1.9-1.9" />
            </svg>
          ),
          title: 'No experts invited',
          description:
            'Browse our network and invite experts to apply to this job.',
          ctaText: 'Browse experts',
          ctaHref: browseURL,
        };
    }
  };

  const content = getEmptyStateContent();

  return (
    <div className={styles.emptyStateContainer}>
      <div className={styles.emptyStateContent}>
        <div className={styles.imageContainer}>
          <div className={styles.image}>{content.icon}</div>
        </div>

        <h3 className={styles.title}>{content.title}</h3>

        {content.description && (
          <p className={styles.description}>{content.description}</p>
        )}

        {content.ctaText && content.ctaHref && (
          <Button
            bsStyle="primary"
            bsSize="large"
            href={content.ctaHref}
            className={styles.ctaButton}
          >
            {content.ctaText}
          </Button>
        )}
      </div>
    </div>
  );
};

NoApplicantsEmptyState.propTypes = {
  tab: PropTypes.oneOf([
    'applied',
    'declined',
    'shortlisted',
    'hired',
    'invited',
  ]),
  browseURL: PropTypes.string,
};

NoApplicantsEmptyState.defaultProps = {
  tab: 'invited',
  browseURL: '/browse',
};

export default NoApplicantsEmptyState;
